import { useChainId } from 'src/hooks/chain';
import { useApiQuery } from 'src/infrastructure/rest-api/useApi';

export const useChainFurnitureZoneQuery = (enabled = true) => {
    const chainId = useChainId();

    return useApiQuery('/api/inventorymanagement/chains/{chainId}/furniturezones', 'get', {
        path: { chainId },
        enabled: enabled && !!chainId,
    });
};
